import { FC, PropsWithChildren } from "react";
import ProgressIndicator from "../ProgressIndicator";

interface StepLayoutProps {
  stepNumber: number;
  numberOfSteps: number;
}

const StepLayout: FC<PropsWithChildren<StepLayoutProps>> = ({
  children,
  stepNumber,
  numberOfSteps,
}) => {
  return (
    <div className="relative grid grid-cols-12 gap w-full px-s m:px-m">
      <div className="col-span-12 m:col-span-10 m:col-start-2 gap h-fit">
        <ProgressIndicator steps={numberOfSteps} currentStep={stepNumber} />
      </div>
      <div className="col-span-12">{children}</div>
    </div>
  );
};

export default StepLayout;
